import React, { useEffect } from 'react';
import './BtsHowToPlay.css';

const STEPS = [
  {
    icon: '👥',
    title: 'สร้างทีมของฉัน',
    desc: 'ชวนเพื่อนตั้งทีมให้ครบ 4 ท่าน',
  },
  {
    icon: '📷',
    title: 'สะสมคะแนน',
    desc: 'สแกน QR Code ท้ายใบเสร็จ / ยอดซื้อ 1 บาท = 1 คะแนน*',
  },
  {
    icon: '🏆',
    title: 'เช็คอันดับทีมของท่าน',
    desc: 'ทีมที่ได้คะแนนสูงสุดรับรางวัล!',
  },
];

const BtsHowToPlay = ({ onAccept }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => onAccept(), 12000);
    return () => { document.body.style.overflow = ''; clearTimeout(timer); };
  }, [onAccept]);

  return (
    <div className="bts-howto__overlay">
      <div className="bts-howto">
        <div className="bts-howto__header">
          <h2 className="bts-howto__title">วิธีเล่นเกม</h2>
          <p className="bts-howto__subtitle">Back to School เปิดเทอมใหญ่ หัวใจว้าวุ่น</p>
        </div>

        <div className="bts-howto__steps">
          {STEPS.map((step, i) => (
            <div key={i} className="bts-howto__step">
              <div className="bts-howto__step-icon">{step.icon}</div>
              <div className="bts-howto__step-info">
                <p className="bts-howto__step-title">{step.title}</p>
                <p className="bts-howto__step-desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bts-howto__footer">
          <p className="bts-howto__note">🎁 รางวัล: กินไก่ย่าง Big C ฟรี 1 ปี!</p>
          <button className="bts-howto__btn" onClick={onAccept}>
            เข้าร่วมเล่นเกม
          </button>
        </div>
      </div>
    </div>
  );
};

export default BtsHowToPlay;
